/**
 * Scope-driven sidebar filtering (Block A). UX only — every API request is
 * re-checked server-side, so a stale/hand-rolled token can at most render
 * links whose pages 403.
 */
type NavItem = { requiredScope?: string; items?: NavItem[]; [k: string]: unknown };

export const filterNavByScopes = <T extends NavItem>(
  items: T[],
  grantedScopes: string[],
): T[] =>
  items
    .filter(
      (item) => !item.requiredScope || grantedScopes.includes(item.requiredScope),
    )
    .map((item) =>
      item.items
        ? { ...item, items: filterNavByScopes(item.items, grantedScopes) }
        : item,
    );
